// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"a6af683b","513":"4a90f0cc","787":"4988d042"}[chunkId] + ".chunk.js";
};